import {ContactPersonOutDto} from "./contact-person.model";
import {AttachmentMinOutDto} from "../component/upload/common/service/document.service";
import {MEMBER_TYPE} from "../../setting/common/service/employer-account/member/member.service";
import {OrganizationMinOutDto} from "../service/organization/organization.service";

export class UserCommonDto {
    username: string;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    contactNumber: string;
    contactNumberType?: string; // TODO : USE CONTACT_NUMBER_TYPE HERE
    userRole: string;
    enabled: boolean;
    userType: USER_TYPE;
}

export class UserInDto extends UserCommonDto {
    password: string;
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    userProfileInDto: UserProfileInDto;
}

export class UserOutDto extends UserCommonDto {
    public id: string;
    profileImageOutDto: AttachmentMinOutDto;
    userProfileOutDto: UserProfileOutDto;
}

export class UserMinOutDto extends UserCommonDto {
    public id: string;
    profileImageUrl: string;
}

export class UserUpdateInDto {
    username: string;
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    userRole: string;
    enabled: boolean;
    userType: USER_TYPE;
}

export class UserProfileInDto {
    profileImageAttachmentId?: string;
    calendlyLink?: string;
}

export class UserProfileOutDto {
    profileImageOutDto: AttachmentMinOutDto;
    calendlyLink?: string;
}

export class SignUpOutDto {
    userOutDto: UserOutDto;
    jwtTokenOutDto: JwtTokenDto;
}

export class LoginInDto {
    username: string;
    password: string;
}

export class SocialLoginInDto {
    idToken: string;
    emailAddress?: string;
    signInProvider?: SIGN_IN_PROVIDER;
}

export class LinkedInCredInDto {
    code?: string;
    clientId?: string;
    redirectUri?: string;
    clientSecret?: string;
    grantType?: string;
    provider?: SIGN_IN_PROVIDER;
}

export class LinkedInUserOutDto {
    linkedInUserInfoOutDto: LinkedInUserInfoOutDto;
    loginOutDto: LoginOutDto;
}

export class LinkedInUserInfoOutDto {
    email?: string;
    name?: string;
    picture?: string;
}

export class JwtTokenDto {
    accessToken: string;
    refreshToken: string;
}

export class LoginOutDto {
    jwtTokenDto: JwtTokenDto;
    userOutDto: UserOutDto;
    domainUserOutDto: DomainUserOutDto;
}

export class ForgotPasswordInDto {
    email: string;
}

export class UsernameInDto {
    email: string;
}

export class ForgotPasswordOutDto {
    email: string;
    username: string;
    otp: string;
}

export class DomainUserOutDto {
    name?: string;
    userId: string;
    memberId: string;
    hasAccessToAiJobAgent?: boolean;
    enabledMemberTabs?: MEMBER_TAB[];
    memberType: MEMBER_TYPE;
    employerMemberStatus?: EMPLOYER_MEMBER_STATUS;
    contactPersonOutDto?: ContactPersonOutDto;
    organizationMinOutDto?: OrganizationMinOutDto;
    accessibleTabs?: TAB_TYPE[];
}

export class ResetPasswordInDto {
    password: string;
}

export class EmailOutDto {
    to: string;
    status: number;
    responseBody: string;
}

export class VerifyOtpOutDto {
    email: string;
}

export enum USER_TYPE {
    CANDIDATE = 'CANDIDATE',
    EMPLOYER = 'EMPLOYER',
    UNIVERSITY = 'UNIVERSITY'
}

export enum TAB_TYPE {
    DASHBOARD = 'dashboard',
    JOB_POSTS = 'job-posts',
    DRIVES = 'drives',
    CHALLENGES = 'challenges',
    APPLICANTS = 'applicants',
    TALENT_POOL = 'talent-pool',
    FORMS = 'forms',
    CONNECTIONS = 'connections',
    REPORTS = 'reports',
    INBOX = 'inbox',
    SETTINGS = 'settings'
}

export enum MEMBER_MODULE {
    CHALLENGES = 'CHALLENGES'
}

export enum MEMBER_TAB {
    ASSESSMENTS = 'ASSESSMENTS',
    COURSES = 'COURSES',
    COMPETITIONS = 'COMPETITIONS',
    HACKATHONS = 'HACKATHONS'
}

export enum EMPLOYER_MEMBER_STATUS {
    PENDING_REQUEST = 'PENDING_REQUEST ',
    ACTIVATED = 'ACTIVATED',
    DEACTIVATED = 'DEACTIVATED'
}

export enum EMPLOYER_STATUS {
    WAITLIST = 'WAITLIST',
    INVITATION_SENT = 'INVITATION_SENT',
    ACTIVATED = 'ACTIVATED',
    DEACTIVATED = 'DEACTIVATED'
}

export enum SIGN_IN_PROVIDER {
    USERNAME_PASSWORD = 'USERNAME_PASSWORD',
    GOOGLE = 'GOOGLE',
    LINKEDIN = 'LINKEDIN'
}
